(function () {
  if (customElements.get('legeit-booking-banner')) return;
  customElements.define('legeit-booking-banner', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      if (this.dataset.home !== 'true') return;
      this.closeButton = this.querySelector('.lgs-booking-banner__close');
      this.closeHandler = () => {
        window.clearTimeout(this.timer);
        this.hidden = true;
        if (!(window.Shopify && Shopify.designMode)) {
          try { sessionStorage.setItem(this.dataset.key, 'dismissed'); } catch (error) {}
        }
      };
      this.closeButton.addEventListener('click', this.closeHandler);
      this.pageShowHandler = (event) => {
        if (event.persisted) this.schedule();
      };
      window.addEventListener('pageshow', this.pageShowHandler);
      this.pageHideHandler = () => {
        window.clearTimeout(this.timer);
        this.hidden = true;
      };
      window.addEventListener('pagehide', this.pageHideHandler);
      this.layoutHandler = () => {
        if (this.layoutFrame) return;
        this.layoutFrame = window.requestAnimationFrame(() => {
          this.layoutFrame = null;
          this.updatePosition();
        });
      };
      window.addEventListener('resize', this.layoutHandler);
      window.addEventListener('scroll', this.layoutHandler, { passive: true });
      this.sidebar = document.querySelector('.sidebar');
      if (this.sidebar) {
        this.menuObserver = new MutationObserver(this.layoutHandler);
        this.menuObserver.observe(this.sidebar, { attributes: true, attributeFilter: ['class', 'style'], subtree: true });
        if (window.ResizeObserver) {
          this.headerObserver = new ResizeObserver(this.layoutHandler);
          this.headerObserver.observe(this.sidebar);
        }
      }
      this.updatePosition();
      this.schedule();
    }
    updatePosition() {
      let bottom = 0;
      document.querySelectorAll('.sidebar, .sidebar .logo, .sidebar__responsive-handles').forEach((element) => {
        const rect = element.getBoundingClientRect();
        // Exclude the tall desktop sidebar; measure only visible header controls.
        if (rect.width > 0 && rect.height > 0 && rect.height < window.innerHeight / 2 && rect.bottom > 0) {
          bottom = Math.max(bottom, rect.bottom);
        }
      });
      this.style.setProperty('--lgs-header-clearance', `${Math.ceil(bottom + 30)}px`);
      this.toggleAttribute('data-overlay-open', Boolean(document.querySelector('.sidebar__menus.opened, .sidebar__search.opened, .sidebar__cart.opened')));
    }
    schedule() {
      window.clearTimeout(this.timer);
      this.hidden = true;
      if (this.dataset.home !== 'true') return;
      const editor = window.Shopify && Shopify.designMode;
      if (!editor) {
        try {
          if (sessionStorage.getItem(this.dataset.key)) return;
        } catch (error) {}
      }
      this.timer = window.setTimeout(() => {
        if (!editor) {
          try {
            if (sessionStorage.getItem(this.dataset.key)) return;
            // Remember the first display for this tab's browsing session.
            sessionStorage.setItem(this.dataset.key, 'shown');
          } catch (error) {}
        }
        this.updatePosition();
        this.hidden = false;
      }, editor ? 0 : Number(this.dataset.delay) * 1000);
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      if (this.closeButton) this.closeButton.removeEventListener('click', this.closeHandler);
      window.removeEventListener('pageshow', this.pageShowHandler);
      window.removeEventListener('pagehide', this.pageHideHandler);
      window.removeEventListener('resize', this.layoutHandler);
      window.removeEventListener('scroll', this.layoutHandler);
      window.cancelAnimationFrame(this.layoutFrame);
      if (this.menuObserver) this.menuObserver.disconnect();
      if (this.headerObserver) this.headerObserver.disconnect();
    }
  });
})();
